export default {
  methods: {
    displayValidationErrors(errorResponse) {
      let errors = [];
      if (errorResponse.data.errors) {
        Object.entries(errorResponse.data.errors).forEach(error => {
          errors.push(error[1][0]);
        });
      } else if(errorResponse.data.message) {
        errors.push(errorResponse.data.message);
      } else if(errorResponse.data.error) {
        errors.push(errorResponse.data.error);
      }

      errors.forEach((error) => {
        this.$notify({
          group: 'main',
          title: 'Error',
          text: error,
          type: 'error',
          speed: 1000,
          duration: 10000,
        });
      })
    }
  }
};
